<template>
    <form>
        <div class="form-row">
            <label class="col-md-3 col-form-label">Name</label>
            <div class="col-md-9">
                <base-input
                    required
                    type="text"
                    name="name"
                    v-validate="modelValidations.name"
                    :error="getError('name')"
                    v-model="newClassroom.name"
                >
                </base-input>
            </div>
        </div>
        <div class="form-row">
            <label class="col-md-3 col-form-label">PIN</label>
            <div class="col-md-9">
                <base-input
                    disabled=""
                    type="text"
                    name="admin_pin"
                    v-model="newClassroom.admin_pin"
                >
                </base-input>
            </div>
        </div>
        <div class="form-row">
            <label class="col-md-3 col-form-label">Email</label>
            <div class="col-md-9">
                <base-input
                    type="email"
                    name="email"
                    v-validate="modelValidations.email"
                    :error="getError('email')"
                    v-model="newClassroom.email"
                >
                </base-input>
            </div>
        </div>
        <div class="form-row" v-if="newClassroom.converted && availableGreetings.length > 0">
            <label class="col-md-3 col-form-label">Greeting</label>
            <div class="col-9">
                <el-select
                    class="select-primary"
                    size="small"
                    placeholder="Classroom greeting"
                    v-model="newClassroom.greeting"
                >
                    <el-option
                        v-for="option in availableGreetings"
                        class="select-primary"
                        :value="option.value"
                        :label="option.label"
                        :key="option.label"
                    >
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="form-row">
            <div class="col-3"></div>
            <div class="col-9">
                <base-checkbox
                    v-model="newClassroom.allow_login"
                    class="pull-left"
                    name="allow_login"
                >
                    Allow login
                </base-checkbox>
            </div>
        </div>
        <div class="form-row">
            <div class="col">
                <base-button
                    native-type="submit"
                    class="float-right"
                    @click.prevent="validate"
                    type="primary"
                    :loading="saving"
                >Save
                </base-button>
            </div>
        </div>
    </form>
</template>
<script>
    import axios from "axios";

    export default {
        name: 'classroom-form',
        props: {
            classroom: {},
        },
        data() {
            return {
                newClassroom: this.classroom,
                availableGreetings: [],
                modelValidations: {
                    email: {
                        required: false,
                        email: true
                    },
                    name: {
                        required: true,
                        min: 5
                    },
                },
                saving: false,
            };
        },
        mounted() {
            this.loadAvailableGreetings();
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName);
            },
            validate() {
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.save();
                    }
                });
            },
            loadAvailableGreetings() {
                return axios({
                    url: this.baseAPIURL + 'classroom/' + this.newClassroom.id + '/greeting', method: 'GET', headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.availableGreetings = resp.data;
                });
            },
            save() {
                this.saving = true;
                axios.post(this.baseAPIURL + 'classroom/' + this.newClassroom.id, {
                    'name': this.newClassroom.name,
                    'email': this.newClassroom.email,
                    'allow_login': this.newClassroom.allow_login,
                    'greeting': this.newClassroom.greeting || null,
                    '_method': 'put',
                }).then((resp) => {
                    this.$notify({
                        message: 'Classroom updated!',
                        type: "success",
                        icon: "fal fa-save",
                    });
                    this.$emit('updated', resp.data.data);
                }).catch(() => {
                    this.$notify({
                        message: 'Oops, something went wrong! ',
                        type: "error",
                        icon: "fal fa-times",
                    });
                }).finally(() => {
                    this.saving = false;
                });
            }
        },
    }
</script>
<style>
    .white-content .el-table table > tbody > tr > td {
        padding: 4px 2px;
    }

</style>
